// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ChoicesController from "./choices_controller"
application.register("choices", ChoicesController)

import CopyArticleContentController from "./copy_article_content_controller"
application.register("copy-article-content", CopyArticleContentController)

import FixedFooterButtonController from "./fixed_footer_button_controller"
application.register("fixed-footer-button", FixedFooterButtonController)

import FlashMessageController from "./flash_message_controller"
application.register("flash-message", FlashMessageController)

import Modal__AnchorLinkController from "./modal/anchor_link_controller"
application.register("modal--anchor-link", Modal__AnchorLinkController)

import Modal__CloseController from "./modal/close_controller"
application.register("modal--close", Modal__CloseController)

import Modal__OpenController from "./modal/open_controller"
application.register("modal--open", Modal__OpenController)

import NotyfController from "./notyf_controller"
application.register("notyf", NotyfController)

import PostSettingFormController from "./post_setting_form_controller"
application.register("post-setting-form", PostSettingFormController)

import PostSettingsBulkController from "./post_settings_bulk_controller"
application.register("post-settings-bulk", PostSettingsBulkController)

import SendingController from "./sending_controller"
application.register("sending", SendingController)

import StoppedSiteNoteController from "./stopped_site_note_controller"
application.register("stopped-site-note", StoppedSiteNoteController)

import TagInputController from "./tag_input_controller"
application.register("tag-input", TagInputController)

import ScrollTopController from "./scroll_top_controller"
application.register("scroll-top", ScrollTopController)

import SyncWordPressModalController from "./sync_word_press_modal_controller"
application.register("sync-word-press-modal", SyncWordPressModalController)

import ToggleActiveController from "./toggle_active_controller"
application.register("toggle-active", ToggleActiveController)

import Validator__TextareaCounterController from "./validator/textarea_counter_controller"
application.register("validator--textarea-counter", Validator__TextareaCounterController)

import WpCategoryCascadeController from "./wp_category_cascade_controller"
application.register("wp-category-cascade", WpCategoryCascadeController)
